import { useMemo } from "react";
import { getDates, getFixedDateList } from '../utils';

type projectArrDataType = [
  string,
  {
    date: string,
    value: string,
    priority?: string | undefined,
  }[] | null,
][] | null;
type ResultType = {
  data: {
    'date': string,
    // 'project_1': string,
    // 'project_2': string,
    // 'project_3': string,
    // 'project_4': string,
    // 'project_5': string,
    'others': string,
    'total_budget': string,
    [keyName: string]: string,
  }[] | null,
  keysMap: {
    'metric': string[], // 指标名称
    'metric_key': string[], // 对应字段名称
  },
};

export default function (props: {
  loading: boolean,
  data: IStudioOverallProjectsBudgetSpendTrendsData | undefined,
  dates: {start_date: string, end_date: string},
}) {
  const {
    loading,
    data,
    dates,
  } = props;

  const orgResult = useMemo(() => {
    const res: ResultType = {
      data: null,
      keysMap: {
        'metric': [],
        'metric_key': [],
      },
    };
    const totalBudget = data?.budget, spendList = data?.spend;
    if (!data || (!totalBudget && !spendList)) return res;
    const dateList = getDates(dates);
    const arrSpend = (spendList && Object.prototype.toString.call(spendList) === '[object Object]') ? Object.entries(spendList) : null;
    // 将数据按A-Z排序
    const sortSpendList = arrSpend ? arrSpend?.sort((a, b) => ((a?.[0] as any) - (b?.[0] as any))) || null : null;
    // Others及Total Budget的数据
    let othersItem: projectArrDataType = null, totalBudgetItem: projectArrDataType = null;
    // 其它正常数据
    const filterOthersItems = sortSpendList ? sortSpendList?.filter((t) => {
      if (t?.[0]?.toLowerCase() == 'others') {
        othersItem = othersItem ? [...othersItem, ['OTHERS', t?.[1]]] : [['OTHERS', t?.[1]]]; // [key(Others), Others对应数据]
        return false;
      } else {
        return true;
      }
    }) || null : null;
    // 把Total Budget的数据整理成相同的格式
    if (totalBudget && Object.prototype.toString.call(totalBudget) === '[object Object]') {
      const tempTotalBudgetItem: [
        string,
        {
          date: string,
          value: string,
        }[] | null,
      ] = ['Total Budget', null], totalBudgetList = [];
      for (const key in totalBudget) {
        totalBudgetList.push({
          'date': key,
          'value': totalBudget?.[key],
        });
      }
      tempTotalBudgetItem[1] = totalBudgetList;
      totalBudgetItem = [tempTotalBudgetItem];
    } else {
      totalBudgetItem = [['Total Budget', [{date: '', value: ''}]]]; // 造一条加数据，确保Total Budget图例显示出来
    }
    if (dateList?.length) {
      const resData: {[keyName: string]: string}[] = [], metric: string[] = [], metricKey: string[] = [];
      for (let i = 0; i < dateList?.length; i ++) {
        const t = dateList?.[i], // 2023-01-01
              spendsObj = getFixedDateList(filterOthersItems, t, metric, metricKey),
              othersObj = getFixedDateList(othersItem, t, metric, metricKey),
              totalBudgetObj = getFixedDateList(totalBudgetItem, t, metric, metricKey);
        resData.push({
          'date': t,
          ...spendsObj,
          ...othersObj,
          ...totalBudgetObj,
        });
      }
      // @ts-ignore
      res.data = resData;
      res.keysMap.metric = metric;
      res.keysMap.metric_key = metricKey;
    }

    return res;
  }, [
    loading,
    dates?.start_date,
    dates?.end_date,
  ]);

  return orgResult;
};
